import { giphyDarkCharcoal } from '@giphy/colors'
import { useContext, useState } from 'react'
import { ControlSize } from 'types'
import { IconButton, TextInput } from 'ui'
import { CopilotContext } from '../context'
import { CopilotApiContext } from '../contexts/api'

type Props = {
    className?: string
    size?: ControlSize
}

export const CopilotDropdownInput = ({ className, size = 'medium' }: Props) => {
    const { presets } = useContext(CopilotContext)
    const { createNewPreset } = useContext(CopilotApiContext)
    const [value, setValue] = useState<string>('')
    const placeholder = !presets.length ? 'Create Your First Preset' : 'Create New Preset'

    function onCreateClick() {
        if (!value) return

        createNewPreset(value)
        setValue('')
    }

    return (
        <TextInput
            className={className}
            color={giphyDarkCharcoal}
            placeholder={placeholder}
            size={size}
            value={value}
            onChange={setValue}
        >
            <IconButton disabled={!value} gradient="indigo-purple" icon="add" size={size} onClick={onCreateClick} />
        </TextInput>
    )
}

export default CopilotDropdownInput
